import { Controller } from "@hotwired/stimulus";

// Switches the Attendance section between the Overview hub and the Attendees list.
// Self-contained (does not rely on Bootstrap's tab JS, which wasn't reliably
// hiding the inactive pane). Reflects the active tab in the URL (?tab=) so the
// View Scans deep-link and refreshes land on the right tab.
export default class extends Controller {
  static targets = ["tab", "pane"];

  connect() {
    // Honour an initial ?tab= or the server-rendered active tab; default to first.
    const params = new URLSearchParams(window.location.search);
    const initial = params.get("tab") ||
      this.tabTargets.find((t) => t.classList.contains("is-active"))?.dataset.tab ||
      this.tabTargets[0]?.dataset.tab;
    this.activate(initial, { updateUrl: false });
  }

  select(event) {
    event.preventDefault();
    this.activate(event.currentTarget.dataset.tab, { updateUrl: true });
  }

  activate(name, { updateUrl } = {}) {
    if (!name) return;

    this.tabTargets.forEach((tab) => {
      tab.classList.toggle("is-active", tab.dataset.tab === name);
      tab.setAttribute("aria-selected", tab.dataset.tab === name);
    });

    this.paneTargets.forEach((pane) => {
      const match = pane.dataset.tab === name;
      pane.classList.toggle("d-none", !match);
    });

    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", name);
      window.history.replaceState({}, "", url);
    }
  }
}
